import { Component } from '@angular/core';
import { ConfigService } from 'app/_services/config.service';

@Component({
    selector: 'app-feed2',
    template: '<school-feed schoolFeed="https://slhe.polkschoolsfl.com/feed/"></school-feed>',
})
export class Feed2Component {
    apiUrl = '';

    constructor(private configService: ConfigService) {
        this.apiUrl = this.configService.hostAddress;
    }
}